import {useQuery} from 'react-query'

import {api} from 'base'

export const useGetCashflowForecast = (date: string) =>
  useQuery<any>(
    ['cashflowForecast', {date}],
    async () => {
      const {data} = await api.get('/dashboard/forecast/cashflow', {
        params: {
          date,
        },
      })
      return data.data
    },
    {keepPreviousData: true}
  )

export const useGetCashflow = (params: any) =>
  useQuery<any>(
    ['cashflow', params],
    async () => {
      const {data} = await api.get('/dashboard/cashflow', {
        params,
      })
      return data.data
    },
    {keepPreviousData: true}
  )

export const useGetForecastPerformance = () =>
  useQuery<any>(
    ['forecastPerformance'],
    async () => {
      const {data} = await api.get('/dashboard/forecast/performance')
      return data.data
    },
    {keepPreviousData: true}
  )

export const useGetDashboardTransactions = (params: any, enabled?: boolean) =>
  useQuery<any>(
    ['dashboardTransactions', params],
    async () => {
      const {data} = await api.get('/dashboard/transactions', {
        params,
      })
      return data.data
    },
    {enabled, keepPreviousData: true}
  )

export const useGetDashboardForecast = (params: any, enabled?: boolean) =>
  useQuery<any>(
    ['dashboardForecast', params],
    async () => {
      const {data} = await api.get('/dashboard/forecast', {
        params,
      })
      return data.data
    },
    {enabled, keepPreviousData: true}
  )

export const useGetCashflowPerformance = () =>
  useQuery<any>(['cashflowPerformance'], async () => {
    const {data} = await api.get('/dashboard/cashflow/performance')
    return data.data
  })
